import { Injectable } from '@angular/core';

import { RewardTargetType } from '@bpos/v1/sports-promo/tokens';
import { AccaBoostConfig, CrmConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { MoneyService } from '@frontend/sports/common/core/feature/money';
import { RewardTokenType } from 'packages/sports/web/app/src/tokens-base/token-base.models';

import { RewardTypeData } from '../models/betslip-result-summary.model';
import { IRewardTokenBadge } from '../models/reward-token-badge.model';

@Injectable({ providedIn: 'root' })
export class RewardTokenBadgeService {
    constructor(
        private sitecore: Sitecore,
        private accaBoostConfig: AccaBoostConfig,
        private crmConfig: CrmConfig,
        private moneyService: MoneyService,
    ) {}

    getBadge(tokenData: RewardTypeData, freebetStake: number): IRewardTokenBadge | undefined {
        const tokenCustomTag =
            tokenData.rewardTargetType === RewardTargetType.WelcomeOffer ? this.sitecore.crmTokens.messages.WelcomeOfferTag : undefined;

        switch (tokenData.tokenType) {
            case RewardTokenType.FreeBet:
                const freebet = this.moneyService.transform(freebetStake, true, 2, true, undefined, undefined, false);

                return {
                    title: freebet + ' ' + this.sitecore.crmTokens.messages.Freebet,
                    icon: this.crmConfig.tokens.icons.freeBet ?? '',
                    backgroundColor: 'reward-token-badge--freebet',
                    typeData: tokenData,
                    count: 1,
                };
            case RewardTokenType.OddsBoost:
                return {
                    title: tokenCustomTag ?? this.sitecore.crmTokens.messages.OddsBoost,
                    icon: this.crmConfig.tokens.icons.oddsBoost ?? '',
                    backgroundColor: 'reward-token-badge--odds-boost',
                    typeData: tokenData,
                    count: 1,
                };
            case RewardTokenType.RiskFreeBet:
                return {
                    title: tokenCustomTag ?? this.sitecore.crmTokens.messages.RiskFree,
                    icon: this.crmConfig.tokens.icons.riskFree,
                    backgroundColor: 'reward-token-badge--risk-free',
                    typeData: tokenData,
                    count: 1,
                };
            case RewardTokenType.BetAndGet:
                return {
                    title: tokenCustomTag ?? this.sitecore.crmTokens.messages.BetAndGet,
                    icon: this.crmConfig.tokens.icons.betAndGet ?? '',
                    backgroundColor: 'reward-token-badge--betandget',
                    typeData: tokenData,
                    count: 1,
                };
            case RewardTokenType.AccaBoost:
                return {
                    title: this.sitecore.accaBoost.AccaBoost,
                    icon: this.accaBoostConfig.icon,
                    backgroundColor: 'reward-token-badge--acca-boost',
                    typeData: tokenData,
                    count: 1,
                };
            default:
                return undefined;
        }
    }
}
